import { app } from '../../../../bootstrap/core';
import { overviewOwnerComponent } from './overviewOwner.component';

app.component(overviewOwnerComponent.name, overviewOwnerComponent);



// WEBPACK FOOTER //
// ./src/app/components/overview/components/owner/overviewOwner.js